import { createAction } from 'kea'

export const updateHeaderFavouritesCount = createAction('update header favourites count', count => ({ count }))
